(function () {
  if (window.__bildwerte) return;
  window.__bildwerte = true;

  var ruhig = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pm(s) { var m = (s || '').match(/\+(\d+)°\s*\/\s*-(\d+)°/); if (m && m[1] === m[2]) return '± ' + m[1] + '°'; return (s || '').replace(/\s*\/\s*/, ' / '); }
  function bis(s) { var m = (s || '').match(/(\d+)\D*$/); return m ? m[1] : ''; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function texte(e, D) {
    var w = D.werte, t = D.woerter, dual = /2/.test(w.monitors_label || ''), art = e.wert;
    var kgU = (w.weight_range_curved_kg && w.weight_range_curved_kg !== w.weight_range_kg) ? t.gebogen.replace('%s', bis(w.weight_range_curved_kg)) : t.flach;
    var r = (w.reach || '').split('·');
    if (art === 'zoll') return [t.zoll, w.size_range_inch, t.flach, 1];
    if (art === 'kg') return [dual ? t.kg2 : t.kg1, w.weight_range_kg, kgU, 1];
    if (art === 'beweg') return [dual ? t.beweg2 : t.beweg1, t.achsen, t.achsenU, 0];
    if (art === 'hoehe') return [t.hoehe, w.has_pole === 'true' ? t.stange : t.feder, dual ? t.hoeheU2 : t.hoeheU1, 0];
    if (art === 'reich_vorne') return [t.vorne, t.bis.replace('%s', bis(r[0])), '', 1];
    if (art === 'reich_seitlich') return [t.seitlich, t.bis.replace('%s', bis(r[1] || '')), '', 1];
    if (art === 'tisch') return [t.tisch, w.table_thickness_range_mm, w.table_thickness_range_mm_grommet ? t.klemmeLoch : t.klemme, 1];
    if (art === 'vesa') return [t.vesa, (w.vesa || '').replace(/ x \d+ mm/g, '').replace(/,\s*/g, ' · '), 'VESA', 0];
    return ['', '', '', 0];
  }

  var SX = 8, SY = 8;
  function L(x1, y1, x2, y2) { var len = Math.hypot((x2 - x1) * SX, (y2 - y1) * SY) + 4; return '<line class="bw__l bw__zieh" style="--len:' + len + '" x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '"/>'; }
  function S(x, y, dx, dy, k) { var a = Math.atan2(dy / k, dx), s = 1.8; function q(t) { return (x - s * Math.cos(a - t)) + ',' + (y - s * Math.sin(a - t) * k); } return '<polyline class="bw__l" points="' + q(.5) + ' ' + x + ',' + y + ' ' + q(-.5) + '"/>'; }
  function M(x1, y1, x2, y2, k) { var px = -(y2 - y1), py = (x2 - x1) * k, l = Math.hypot(px, py) || 1; var nx = px / l * 1.4 / k, ny = py / l * 1.4;
    return L(x1, y1, x2, y2) + '<line class="bw__l" x1="' + (x1 - nx) + '" y1="' + (y1 - ny) + '" x2="' + (x1 + nx) + '" y2="' + (y1 + ny) + '"/><line class="bw__l" x1="' + (x2 - nx) + '" y1="' + (y2 - ny) + '" x2="' + (x2 + nx) + '" y2="' + (y2 + ny) + '"/>'; }
  function B(cx, cy, r, a0, a1, k) { var p0 = [cx + r * Math.cos(a0), cy + r * Math.sin(a0) * k], p1 = [cx + r * Math.cos(a1), cy + r * Math.sin(a1) * k]; var len = r * SX * Math.abs(a1 - a0) + 4;
    return '<path class="bw__l bw__zieh" style="--len:' + len + '" d="M' + p0 + ' A' + r + ' ' + (r * k) + ' 0 ' + (Math.abs(a1 - a0) > Math.PI ? 1 : 0) + ' 1 ' + p1 + '"/>'; }
  function MK(x, y, t) { return '<span class="bw__marke" style="left:' + x + '%;top:' + y + '%">' + esc(t) + '</span>'; }

  function zeichnung(e, k, D) {
    var p = e.p || [], s = '', h = '', w = D.werte, t = D.woerter;
    if (e.wert === 'merkmal') {
      if (p.length < 2 || !e.t) return { s: '', h: '' };
      var T = e.texte || {}, tx = T[D.sprache] || {}, de = T.de || {};
      var ti = tx.titel || de.titel || '', ze = tx.titel ? (tx.zeile || '') : (de.zeile || '');
      s = '<ellipse class="bw__ring" cx="' + p[0] + '" cy="' + p[1] + '" rx="1.6" ry="' + (1.6 * k) + '"/><ellipse class="bw__anker" cx="' + p[0] + '" cy="' + p[1] + '" rx=".9" ry="' + (.9 * k) + '"/>' + L(p[0], p[1], e.t[0] + 2, e.t[1] + 2 * k);
      h = '<div class="bw__mm" style="left:' + e.t[0] + '%;top:' + e.t[1] + '%"><b>' + esc(ti) + '</b>' + (ze ? '<small>' + esc(ze) + '</small>' : '') + '</div>';
      return { s: s, h: h };
    }
    if (p.length < 4) return { s: '', h: '' };
    var x1 = p[0], y1 = p[1], x2 = p[2], y2 = p[3];
    if (e.wert === 'zoll' || e.wert === 'hoehe') s = L(x1, y1, x2, y2) + S(x2, y2, x2 - x1, y2 - y1, k) + S(x1, y1, x1 - x2, y1 - y2, k);
    if (e.wert === 'kg') s = L(x1, y1, x2, y2) + S(x2, y2, x2 - x1, y2 - y1, k);
    if (e.wert === 'reich_vorne' || e.wert === 'reich_seitlich' || e.wert === 'tisch') s = M(x1, y1, x2, y2, k);
    if (e.wert === 'beweg') {
      var r = Math.hypot(x2 - x1, (y2 - y1) / k);
      s = '<g class="bw__wipp">' + B(x1, y1, r * .95, -2.2, -.95, k) + '</g>' + B(x1 + r * 1.25, y1, r * .6, -1.1, 1.1, k) + B(x1, y1 + r * 1.15 * k, r * .7, .5, 2.65, k);
      h = MK(x1, y1 - r * 1.25 * k, t.drehen + ' ' + pm(w.rotation_range)) + MK(x1 + r * 2.1, y1, t.neigen + ' ' + pm(w.tilt_range)) + MK(x1, y1 + r * 2.1 * k, t.schwenken + ' ' + pm(w.swivel_range));
    }
    if (e.wert === 'vesa') {
      var q = Math.abs(x2 - x1), qh = q * k;
      s = '<rect class="bw__vq bw__vq--gross" x="' + (x1 - q) + '" y="' + (y1 - qh) + '" width="' + (2 * q) + '" height="' + (2 * qh) + '"/><rect class="bw__vq" x="' + (x1 - q * .75) + '" y="' + (y1 - qh * .75) + '" width="' + (1.5 * q) + '" height="' + (1.5 * qh) + '"/>';
      h = MK(x1, y1 + qh + 3, '75 × 75 · 100 × 100');
    }
    if (e.wert === 'reich_vorne' || e.wert === 'reich_seitlich') h = MK((x1 + x2) / 2, (y1 + y2) / 2 - 3.5, texte(e, D)[1] + ' ' + (e.wert === 'reich_seitlich' ? t.seitlichM : t.vorneM));
    if (e.t) {
      var tt = texte(e, D);
      if (tt[1]) h += '<div class="bw__wert" style="left:' + e.t[0] + '%;top:' + e.t[1] + '%"><small>' + esc(tt[0]) + '</small><b' + (tt[3] ? ' data-bw-zahl' : '') + '>' + esc(tt[1]) + '</b>' + (tt[2] ? '<small>' + esc(tt[2]) + '</small>' : '') + '</div>';
    }
    return { s: s, h: h };
  }

  function flaeche(img, box) {
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if (!nw || !nh) return null;
    var ri = img.getBoundingClientRect(), rb = box.getBoundingClientRect(), cs = getComputedStyle(img);
    var pl = parseFloat(cs.paddingLeft) || 0, pr = parseFloat(cs.paddingRight) || 0, pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0;
    var bw = ri.width - pl - pr, bh = ri.height - pt - pb;
    if (!bw || !bh) return null;
    var fit = cs.objectFit, sc = fit === 'cover' ? Math.max(bw / nw, bh / nh) : fit === 'contain' ? Math.min(bw / nw, bh / nh) : bw / nw;
    var w = nw * sc, h = nh * sc;
    if (fit !== 'cover' && fit !== 'contain') { w = bw; h = bh; }
    var pos = (cs.objectPosition || '50% 50%').split(' ');
    function anteil(v) { return /%$/.test(v) ? parseFloat(v) / 100 : .5; }
    return { l: ri.left - rb.left + pl + (bw - w) * anteil(pos[0]), t: ri.top - rb.top + pt + (bh - h) * anteil(pos[1] || '50%'), w: w, h: h };
  }

  function zaehlen(el) {
    if (ruhig) return;
    el.querySelectorAll('[data-bw-zahl]').forEach(function (z) {
      if (!z.__voll) z.__voll = z.textContent;
      var t = z.__voll, m = t.match(/(\d+)(?!.*\d)/);
      if (!m) return;
      var ziel = +m[1], vor = t.slice(0, m.index), nach = t.slice(m.index + m[1].length), t0 = null;
      function f(ts) { if (!t0) t0 = ts; var q = Math.min(1, (ts - t0) / 900); q = 1 - Math.pow(1 - q, 3); z.textContent = vor + Math.round(ziel * q) + nach; if (q < 1) requestAnimationFrame(f); }
      requestAnimationFrame(f);
    });
  }

  function tonMessen(url, eintraege, fertig) {
    var k = new Image();
    k.crossOrigin = 'anonymous';
    k.onload = function () {
      try {
        var W = 96, H = Math.max(1, Math.round(96 * k.naturalHeight / k.naturalWidth));
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d'); x.drawImage(k, 0, 0, W, H);
        var d = x.getImageData(0, 0, W, H).data, summe = 0, n = 0;
        function feld(x0, x1, y0, y1, gew) {
          var a = Math.floor(x0 * W / 100), b = Math.max(a + 1, Math.floor(x1 * W / 100));
          var o = Math.floor(y0 * H / 100), u = Math.max(o + 1, Math.floor(y1 * H / 100));
          for (var yy = o; yy < u && yy < H; yy++) for (var xx = a; xx < b && xx < W; xx++) {
            var i = (yy * W + xx) * 4;
            var l = d[i + 3] < 30 ? 255 : .2126 * d[i] + .7152 * d[i + 1] + .0722 * d[i + 2];
            summe += l * gew; n += gew;
          }
        }
        eintraege.forEach(function (e) {
          var p = e.p || [], t = e.t || [p[0] || 0, p[1] || 0];
          var xs = p.filter(function (_, j) { return j % 2 === 0; }).concat([t[0], t[0] + 28]);
          var ys = p.filter(function (_, j) { return j % 2 === 1; }).concat([t[1], t[1] + 14]);
          feld(Math.max(0, Math.min.apply(0, xs)), Math.min(100, Math.max.apply(0, xs)), Math.max(0, Math.min.apply(0, ys)), Math.min(100, Math.max.apply(0, ys)), 1);
          feld(t[0], Math.min(100, t[0] + 28), t[1], Math.min(100, t[1] + 14), 2);
        });
        fertig(n && summe / n <= 150 ? 'hell' : 'dunkel');
      } catch (e) { fertig('dunkel'); }
    };
    k.onerror = function () { fertig('dunkel'); };
    k.src = url;
  }

  function legen(medium, eintraege, D) {
    if (medium.querySelector(':scope > .bw')) return;
    var img = medium.querySelector('img');
    if (!img) return;
    var bw = document.createElement('div');
    bw.className = 'bw' + (ruhig ? ' bw--ruhig' : '');
    bw.setAttribute('aria-hidden', 'true');
    if (getComputedStyle(medium).position === 'static') medium.style.position = 'relative';
    medium.appendChild(bw);
    var ton = '';
    eintraege.forEach(function (e) { if (e.ton === 'hell' || e.ton === 'dunkel') ton = e.ton; });
    if (ton) bw.classList.toggle('bw--hell', ton === 'hell');
    else {
      var quelle = (img.currentSrc || img.src || '').split('?')[0];
      if (quelle) tonMessen(quelle + '?width=96', eintraege, function (t) { bw.classList.toggle('bw--hell', t === 'hell'); });
    }

    function bauen() {
      var f = flaeche(img, medium);
      if (!f) return;
      bw.style.left = f.l + 'px'; bw.style.top = f.t + 'px'; bw.style.width = f.w + 'px'; bw.style.height = f.h + 'px';
      var k = f.w / f.h;
      if (bw.__w && Math.abs(bw.__w - f.w) < 1 && Math.abs(bw.__h - f.h) < 1) return;
      bw.__w = f.w; bw.__h = f.h;
      SX = f.w / 100; SY = f.h / 100;
      var s = '', h = '';
      eintraege.forEach(function (e) { var z = zeichnung(e, k, D); s += z.s; h += z.h; });
      var an = bw.classList.contains('bw--an');
      bw.innerHTML = '<svg class="bw__zeichnung" viewBox="0 0 100 100" preserveAspectRatio="none" focusable="false">' + s + '</svg>' + h;
      if (an) bw.classList.add('bw--an');
    }
    if (img.complete) bauen(); else img.addEventListener('load', bauen, { once: true });
    if (window.ResizeObserver) { var ro = new ResizeObserver(bauen); ro.observe(medium); ro.observe(img); }

    if (!window.IntersectionObserver) { bw.classList.add('bw--an'); return; }
    var beob = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.intersectionRatio >= .55 && !bw.classList.contains('bw--an')) {
          bw.classList.add('bw--an'); zaehlen(bw); beob.disconnect();
        }
      });
    }, { threshold: [0, .55, 1] });
    beob.observe(medium);
  }

  function lauf() {
    document.querySelectorAll('script[data-bildwerte]').forEach(function (sk) {
      if (sk.__bw) return;
      sk.__bw = true;
      var D;
      try { D = JSON.parse(sk.textContent); } catch (e) { return; }
      if (!D || !D.liste || !D.liste.length) return;
      var je = {};
      D.liste.forEach(function (e) { var id = String(e.bild || '').split('/').pop(); (je[id] = je[id] || []).push(e); });
      var bereich = sk.closest('.shopify-section') || document;
      function suchen() {
        bereich.querySelectorAll('.product-media[data-media-id]').forEach(function (m) {
          if (m.closest('dialog')) return;
          var liste = je[m.getAttribute('data-media-id')];
          if (liste) legen(m, liste, D);
        });
      }
      suchen();
      if (window.MutationObserver) {
        var geplant = false;
        new MutationObserver(function () {
          if (geplant) return;
          geplant = true;
          requestAnimationFrame(function () { geplant = false; suchen(); });
        }).observe(bereich, { childList: true, subtree: true });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lauf); else lauf();
})();
